class Menu {
	constructor(config) {
		this.config = Object.assign({
			scope: '.navbar-collapse'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initEventListeners();
	}

	initEventListeners() {
		this.$scope.on('click', '.dropdown-item', this.closeMenu.bind(this));
	}

	closeMenu() {
		this.$scope.collapse('hide');
	}
}

export default new Menu;